<template>
  <table class="print-table">
    <thead>
      <tr>
        <th width="24">序号</th>
        <th width="100">产品名称</th>
        <th width="120">产品规格(mm)</th>
        <th width="60">单位</th>
        <th width="60">数量</th>
        <th width="60">单价(元)</th>
        <th width="60">金额(元)</th>
        <th width="120">备注</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in selfData" :key="index">
        <td>{{ index + 1 }}</td>
        <td>{{ item.goods_name }}</td>
        <td>{{ item.goods_spec }}</td>
        <td>{{ item.goods_unit }}</td>
        <td>{{ item.goods_count }}</td>
        <td>{{ item.goods_price }}</td>
        <td>{{ item.goods_amount }}</td>
        <td>{{ item.goods_remark }}</td>
      </tr>
      <tr class="f-bold">
        <td>合计</td>
        <td colspan="3">{{ $util.amountUppercase(totalSalesAmount) }}</td>
        <td>{{ totalCounts }}</td>
        <td></td>
        <td>{{ totalSalesAmount }}</td>
        <td></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfData: [],
      totalCounts: 0,
      totalSalesAmount: 0
    }
  },
  mounted() {
    this.selfData = this.$util.deepCopy(this.data)
    this.totalCounts = this.$util.listFieldTotal(this.selfData, 'goods_count')
    this.totalSalesAmount = this.$util.listFieldTotal(this.selfData, 'goods_amount')
  }
}
</script>

<style lang="less" scoped>
.print-table {
  margin: 5px 0;
  width: 100%;
  border-collapse: collapse;
  border-left: 1px solid #000;
  border-top: 1px solid #000;
  text-align: center;
}
.print-table th,
.print-table td {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 2px;
  overflow-wrap: anywhere;
}
</style>
